/* Monavida magazine (USA): reading progress bar, sticky button, three-question quiz.
   Loaded by every mv-magazine* section; the guard below makes it run once.
   All text comes from the theme editor via the markup; nothing customer-facing lives here. */
(function () {
  if (window.mvMagazineInit) return;
  window.mvMagazineInit = true;

  function init() {
    var bar = document.querySelector('.js-mvm-progress');
    var sticky = document.querySelector('.js-mvm-sticky');
    var trigger = document.querySelector('.js-mvm-sticky-trigger');
    var ticking = false;

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (bar) {
        var pct = max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0;
        bar.style.transform = 'scaleX(' + pct / 100 + ')';
      }
      if (sticky) {
        var show = trigger
          ? trigger.getBoundingClientRect().bottom < 0
          : window.scrollY > window.innerHeight * 1.5;
        sticky.classList.toggle('visible', show);
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    document.querySelectorAll('.js-mvm-quiz').forEach(initQuiz);
  }

  function initQuiz(quiz) {
    var steps = quiz.querySelectorAll('.recommender-step');
    var dots = quiz.querySelectorAll('.recommender-dot');
    var list = quiz.querySelector('.js-mvm-quiz-reasons');

    function showStep(step) {
      steps.forEach(function (s) {
        s.classList.toggle('active', s.getAttribute('data-step') === String(step));
      });
      dots.forEach(function (d, i) {
        var done = step === 'result' || i < step;
        d.classList.toggle('active', done);
        d.classList.toggle('current', i === step - 1);
      });
    }

    quiz.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var stepEl = input.closest('[data-step]');
      var step = parseInt(stepEl && stepEl.getAttribute('data-step'), 10);
      window.setTimeout(function () {
        if (step < 3) {
          showStep(step + 1);
          return;
        }
        var chosen = quiz.querySelectorAll('input[type="radio"]:checked');
        if (chosen.length < 3 || !list) return;
        list.textContent = '';
        chosen.forEach(function (c) {
          var reason = c.getAttribute('data-reason');
          if (!reason) return;
          var li = document.createElement('li');
          li.textContent = reason;
          list.appendChild(li);
        });
        showStep('result');
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
